const isProduction = process.env.REACT_APP_NODE_ENV === "production";

export const Config = {
  apiUrl: "/api/v1/",
  apiBaseUrl: isProduction
    ? process.env.REACT_APP_BASE_URL // Production URL
    : process.env.REACT_APP_BASE_URL_STAGING || "http://localhost:8000", //Dev URL

  // apiBaseUrl: process.env.REACT_APP_BASE_URL || "http://localhost:8000",
  // defaults: {
  //   paginator: {
  //     pageKey: "page",
  //     limitKey: "limit",
  //     searchKey: "search",
  //     limit: 10,
  //     startPage: 1,
  //   },
  // },
};
